import script from "./WatercolorShapeDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatercolorShapeDialog.vue?vue&type=script&setup=true&lang=ts"

import "./WatercolorShapeDialog.vue?vue&type=style&index=0&id=651cc0d4&lang=css"

const __exports__ = script;

export default __exports__